import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Connect")
  ])
], -1)
const _hoisted_5 = { class: "row w-100" }
const _hoisted_6 = { class: "col-md-12 col-lg-12 my-1" }
const _hoisted_7 = { class: "row w-100" }
const _hoisted_8 = { class: "col-md-6 col-lg-5 my-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_10 = { class: "col-md-6 col-lg-5 my-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_12 = { class: "col-2 my-1" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Connect ")

import { computed, ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { IndexType } from "@/types/store";
import { Field } from "@/types/components";
import { Form, FormActions } from "vee-validate";
import { Promotion } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { dialerApi } from "@/conection/index";
import { formatNumber } from "@/util/utils.ts";
import * as yup from "yup";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const form = ref<IndexType<Field>>({});
const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const loading = ref(false);
//computed
const schema = yup.object({
	number1: yup.string().matches(/^\d{3,}$/, "Phone number 1 is not valid"),
	number2: yup.string().matches(/^\d{3,}$/, "Phone number 2 is not valid"),
	connectMessage: yup.string().matches(/^[\w\s\p{P}\p{S}]+$/u, "Message is not valid, It should not contain accents.").required("Message is required"),

});

async function onSubmit(values: any) {
	loading.value = true;
	try {
		const response = await dialerApi.post("/dialer/connect", {
			from: {
				number: formatNumber(values.number1),
				context: "llamada_saliente_internacional",
			},
			to: {
				number: formatNumber(values.number2),
				context: "llamada_saliente_internacional",
			},
			text: values.connectMessage
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Call sent successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Call has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Call has not been sent`,
			type: "error",
		});
	}

	loading.value = false;
}

function onInvalidSubmit(values: iInvalidSubmit) {
	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onSubmit: _cache[0] || (_cache[0] = (e) => onSubmit(e)),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(BaseInput, {
                        type: "textarea",
                        name: "connectMessage",
                        label: "Message",
                        placeholder: "Hello !",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        alternative: "",
                        inputGroupClasses: "w-75"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(BaseInput, {
                        name: "number1",
                        label: "Phone number 1",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        alternative: "",
                        inputGroupClasses: "w-75"
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(BaseInput, {
                        name: "number2",
                        label: "Phone number 2",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        alternative: "",
                        inputGroupClasses: "w-75"
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_base_button, {
                        disabled: loading.value,
                        "native-type": "submit"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            (!loading.value)
                              ? (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 0,
                                  size: 20,
                                  color: "#FFFFF",
                                  class: "no-inherit"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Promotion))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (loading.value)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                              : _createCommentVNode("", true),
                            _hoisted_15
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})